module.exports = __webpack_public_path__ + "img/v-q-1.34147f97.jpg";